import type { Option } from "src/components/SelectV2/SelectV2.types.ts";
import React, { type ReactNode, useEffect, useRef, useState } from "react";

import { selectClasses } from "src/components/SelectV2/SelectV2.constants.ts";
import * as styles from "src/components/SelectV2/SelectV2.style.ts";
import { SpinnerSpinningMini as Spinner } from "src/lib/ui-icon-v2";

export const ButtonPreview = <Value = unknown,>({
  disabled,
  placeholder,
  flatOptions,
  isLoadingData,
  isLoadingSelectedOption,
  value,
  fallbackOptions,
  isOpen,
}: {
  disabled: boolean;
  flatOptions: Option<Value>[];
  placeholder?: ReactNode;
  isLoadingData: boolean;
  isLoadingSelectedOption: boolean;
  value: Value | "";
  fallbackOptions: Option<NoInfer<Value>>[];
  isOpen: boolean;
}) => {
  const labelRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const selectedOption = [...flatOptions, ...fallbackOptions].find(
    (option) => option.value === value,
  );

  useEffect(() => {
    const el = labelRef.current;
    if (!el) return;

    const isOverflow = el.scrollWidth > el.clientWidth;
    setIsOverflowing(isOverflow);
  }, [selectedOption?.label]);

  return (
    <div
      className={selectClasses.preview}
      css={styles.preview({
        disabled: disabled,
        isPlaceholder: !selectedOption,
        isButton: true,
        isOpen,
      })}
    >
      {isLoadingSelectedOption ? (
        <Spinner />
      ) : selectedOption?.renderOption ? (
        selectedOption?.renderOption(selectedOption)
      ) : (
        <div
          css={styles.previewInner}
          ref={labelRef}
          title={isOverflowing ? selectedOption?.label : undefined}
        >
          {selectedOption ? selectedOption?.label : placeholder}
        </div>
      )}
    </div>
  );
};
